import React from 'react'
import PropTypes from 'prop-types'

import { useFetchAPI } from 'hooks'
import { Loading } from 'ui/acro'

import PlanLayout from './PlanLayout'

const Plan = ({ planSlug, videoSession }) => {
  const [{ data: plan, loading, error }] = useFetchAPI(`plans/${planSlug}`)

  return (
    <Loading loading={loading} error={error}>
      {plan && <PlanLayout plan={plan} videoSession={videoSession} />}
    </Loading>
  )
}

Plan.propTypes = {
  planSlug: PropTypes.string.isRequired,
  videoSession: PropTypes.string
}

export default Plan
